/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createAdminProgramPeriod } from '../fn/admin-program-periods/create-admin-program-period';
import { CreateAdminProgramPeriod$Params } from '../fn/admin-program-periods/create-admin-program-period';
import { findOneAdminProgramPeriod } from '../fn/admin-program-periods/find-one-admin-program-period';
import { FindOneAdminProgramPeriod$Params } from '../fn/admin-program-periods/find-one-admin-program-period';
import { listAdminProgramPeriod } from '../fn/admin-program-periods/list-admin-program-period';
import { ListAdminProgramPeriod$Params } from '../fn/admin-program-periods/list-admin-program-period';
import { ProgramPeriod } from '../models/program-period';
import { updateAdminProgramPeriod } from '../fn/admin-program-periods/update-admin-program-period';
import { UpdateAdminProgramPeriod$Params } from '../fn/admin-program-periods/update-admin-program-period';

@Injectable({ providedIn: 'root' })
export class AdminProgramPeriodsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminProgramPeriodControllerListAdminProgramPeriod()` */
  static readonly AdminProgramPeriodControllerListAdminProgramPeriodPath = '/admin/program-periods';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAdminProgramPeriod()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAdminProgramPeriod$Response(
    params?: ListAdminProgramPeriod$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<ProgramPeriod>>> {
    return listAdminProgramPeriod(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAdminProgramPeriod$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAdminProgramPeriod(
    params?: ListAdminProgramPeriod$Params,
    context?: HttpContext
  ): Observable<Array<ProgramPeriod>> {
    return this.listAdminProgramPeriod$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProgramPeriod>>): Array<ProgramPeriod> => r.body)
    );
  }

  /** Path part for operation `adminProgramPeriodControllerCreateAdminProgramPeriod()` */
  static readonly AdminProgramPeriodControllerCreateAdminProgramPeriodPath = '/admin/program-periods';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAdminProgramPeriod()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAdminProgramPeriod$Response(
    params: CreateAdminProgramPeriod$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ProgramPeriod>> {
    return createAdminProgramPeriod(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAdminProgramPeriod$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAdminProgramPeriod(params: CreateAdminProgramPeriod$Params, context?: HttpContext): Observable<ProgramPeriod> {
    return this.createAdminProgramPeriod$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProgramPeriod>): ProgramPeriod => r.body)
    );
  }

  /** Path part for operation `adminProgramPeriodControllerFindOneAdminProgramPeriod()` */
  static readonly AdminProgramPeriodControllerFindOneAdminProgramPeriodPath = '/admin/program-periods/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findOneAdminProgramPeriod()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOneAdminProgramPeriod$Response(
    params: FindOneAdminProgramPeriod$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ProgramPeriod>> {
    return findOneAdminProgramPeriod(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findOneAdminProgramPeriod$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOneAdminProgramPeriod(
    params: FindOneAdminProgramPeriod$Params,
    context?: HttpContext
  ): Observable<ProgramPeriod> {
    return this.findOneAdminProgramPeriod$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProgramPeriod>): ProgramPeriod => r.body)
    );
  }

  /** Path part for operation `adminProgramPeriodControllerUpdateAdminProgramPeriod()` */
  static readonly AdminProgramPeriodControllerUpdateAdminProgramPeriodPath = '/admin/program-periods/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAdminProgramPeriod()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAdminProgramPeriod$Response(
    params: UpdateAdminProgramPeriod$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ProgramPeriod>> {
    return updateAdminProgramPeriod(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAdminProgramPeriod$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAdminProgramPeriod(params: UpdateAdminProgramPeriod$Params, context?: HttpContext): Observable<ProgramPeriod> {
    return this.updateAdminProgramPeriod$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProgramPeriod>): ProgramPeriod => r.body)
    );
  }
}
